var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._m(0),_c('div',{staticClass:"downBtn"},[_c('span',{on:{"click":_vm.downLoad}},[_vm._v("立即下载")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_c('img',{attrs:{"src":require("@/assets/images/headerLogo.png"),"alt":""}})]),_c('dd',[_c('p',[_vm._v("权利卫士")]),_c('span',[_vm._v("随时随地 取证固证")])])])
}]

export { render, staticRenderFns }